export default {
  SET_SUBCATEGORY(state, payload) {
    state.subcategory = payload;
  },
};
